module.exports = __webpack_public_path__ + "media/images/dollar-1467dea086eb12f6546b90cd5a92a4d5.svg";